<template>
    <div>
        <el-dialog
            :visible.sync="visible"
            :close-on-click-modal="false"
            :show="show"
            :append-to-body="true"
            width="900px"
            :show-close="false">
            <div slot="title" class="register-title">用户身份认证</div>
            <!-- <div slot="title" class="register-title">用户身份认证</div> -->
            <div>
              <!-- <p class="register-title">用户身份认证</p> -->
              <div class="loginBox">
                <el-form :model="formData" ref="register" @submit.prevent="register()" :rules="loginrule">
                  <table>
                    <tr>
                      <td colspan="2">
                        <el-form-item label="身份类型" prop="userType">
                          <el-radio-group v-model="formData.userType" class="layui-input-block line-height40 flex-layout flex-v-align-center">
                            <el-radio v-for="(item,index) in types" :label="item.userType" :value="item.userType" :key="item.text">{{item.text}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-form-item label="用户名" prop="userName">
                          <el-input type="text" v-model="formData.userName" maxlength="20" placeholder="用户名长度为3到20个字符,不可包含符号"/>
                        </el-form-item>
                      </td>
                      <td>
                        <el-form-item label="真实姓名" prop="contacts">
                          <el-input type="text" v-model="formData.contacts" maxlength="20" placeholder="请输入真实姓名"/>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-form-item label="密码" prop="password">
                          <el-input type="password" v-model="formData.password" autocomplete="new-password" maxlength="50" placeholder="请输入密码"/>
                        </el-form-item>
                      </td>
                      <td>
                        <el-form-item label="确认密码" prop="repassword">
                          <el-input type="password" v-model="formData.repassword" autocomplete="new-password" maxlength="50" placeholder="请再次输入密码"/>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-form-item label="单位名称" prop="orgnName">
                          <el-input type="text" v-model="formData.orgnName" maxlength="50" placeholder="请输入准确的单位全称"/>
                        </el-form-item>
                      </td>
                      <td>
                        <el-form-item label="电子邮箱" prop="email">
                          <el-input type="text" v-model="formData.email" maxlength="50" placeholder="请输入电子邮箱"/>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td><el-button type="primary" @click="register('register','save')" class="saveBotton">完成认证，并完善更多信息</el-button></td>
                      <td><el-button type="primary" @click="register('register','goon')" class="loginBotton">完成认证，继续操作</el-button></td>
                    </tr>
                  </table>
                </el-form>
                <p class="cancle-text cursor" @click="closeDialog()">取消</p>
              </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  data () {
    var checkPassword = (rule, value, callback) => {
      if (this.formData.password) {
        if (this.formData.password!=value) {
          callback(new Error("两次输入的密码不一致"));
        } else {
          callback();
        }
      }else{
        callback();
      }
    };
    var isEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        const reg = this.global.emailReg;
        const email = reg.test(value);
        if (!email) {
          callback(new Error("请输入正确的电子邮箱"));
        } else {
          callback();
        }
      }
    };
    var checkName = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        if(value.length>20 || value.length<3){
          callback(new Error("用户名长度不正确"));
        }else{
          var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
          if(reg.test(value)){
            callback(new Error('用户名不能包含特殊符号'));
          }else{
            this.$axios.get(this.global.url+'cl/isUserName',{
              params:  {userName:value}
            }).then( res => {
               var code = res.data.code;
               if(code==200){
                 callback();
               }else{
                 callback(res.data.msg);
               }
            });
          }
        }
      }
    };
    return {
      visible: this.show,
      types:[{text:'企业/机构',userType:'enp'},{text:'专家',userType:'exp'}],
      formData:{
        repassword:'',
        userType:'',
        orgnName:'',
        userName:'',
        password:'',
        contacts:'',
        email:''
      },
      loginrule:{
        userType:[
          {required:true,message:'请选择身份类型',trigger:'blur'},
        ],
        userName:[
          {required:true,message:'请输入用户名',trigger:'blur'},
          {validator: checkName, trigger: "blur"}
        ],
        password:[
          {required:true,message:'请输入密码',trigger:'blur'},
        ],
        repassword:[
          {required:true,message:'请再次输入密码',trigger:'blur'},
          {validator: checkPassword,trigger:'blur'}
        ],
        contacts:[
          {required:true,message:'请输入真实姓名',trigger:'blur'},
          {min:2,max:20,message:'真实姓名长度2到20个字符',trigger:'blur'}
        ],
        orgnName:[
          {required:true,message:'请输入准确的单位全称',trigger:'blur'},
          {min:2,max:50,message:'单位全称长度不正确',trigger:'blur'}
        ],
        email:[
          {required:true,message:'请输入电子邮箱',trigger:'blur'},
          {validator: isEmail, trigger: "blur"}
        ]
      }
    }
  },
  props: {
      show: {
          type: Boolean,
          default: false
      },
      pageName:''
  },
  watch: {
    show () {
      this.visible = this.show;
    }
  }
  ,methods:{
    register(formName,type){
      this.$refs[formName].validate(valid => {
          if (valid) {
           let fd = new FormData();
           fd.append('userType',this.formData.userType);
           fd.append('orgnName',this.formData.orgnName);
           fd.append('userName',this.formData.userName);
           fd.append('password',this.formData.password);
           fd.append('contacts',this.formData.contacts);
           fd.append('email',this.formData.email);
           this.$axios.post(this.global.url+'user/modifyUserType',fd).then(res => {
               var code = res.data.code;
               if(code==200){
                 this.visible = false;
                 if(type=='save'){
                  this.$router.push({path:"/user/userInfo"})
                 }else if(this.pageName){
                  this.$emit('fatherClose');
                 }
               }else{
                 this.$message.error(res.data.msg);
               }
           }).catch(err => {
           });
          } else {
            return false
          }
      })
    },closeDialog(){
      let router_path = this.$route.path
      if(router_path=='/'){
        this.visible = false;
      }else{
        this.$router.push({path:"/"})
      }
    },typeChange(){
        var stageselect=document.getElementById("stage");
        var index=stageselect.selectedIndex ;
        this.stageStr = stageselect.options[index].text;
      }
  }
};
</script>

<style scoped>
  .header-title{padding:0 0 0 40px;}
  .loginBox{text-align:center;width:80%;height:500px;margin:0 auto;}
  .loginBox input{padding-left: 10px;height: 36px;line-height: 36px;color: #2a2a2a;background-color: #ffffff;border-top:none;border-left:none;border-right:none;border-bottom: 1px solid #cccccc;font-family: Microsoft Yahei;border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; }
  .loginBotton{width:100%;font-size:16px;padding:15px 0;margin-top:10px;background:#522e95;border-color:#522e95;}
  .saveBotton{width:100%;font-size:16px;padding:15px 0;margin-top:10px;background:#1184d5;border-color:#1184d5;}
  .register-title{text-align:center;font-size:22px;color:#522e95;font-weight:bold;padding:10px 0;}
  .cancle-text{text-align:center;color:#999; margin-top:30px;text-decoration:underline;}

  table{width:100%;}
  table tr td{padding:0 10px;}

  /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {color: #522e95;}
  /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {background-color: #522e95;border-color: #522e95;}
  /deep/ .el-checkbox__inner:hover {border-color: #522e95 !important;;}
  /deep/ .el-radio__input.is-checked .el-radio__inner {border-color: #522e95 !important;;background:#522e95 !important;;}
  /deep/ .el-radio__input.is-checked + .el-radio__label {color: #522e95 !important;;}
  /deep/ .el-radio__inner:hover {border-color: #522e95 !important;;}
  .element-select{padding-left: 10px;height: 36px;line-height: 36px;color: #2a2a2a;background-color: #ffffff;border: 1px solid #cccccc;font-family: Microsoft Yahei;border-radius: 4px;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
      -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
      transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; }
</style>
